"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_SLOT_NAME = void 0;
exports.INTERNAL_SLOT_NAME = '__root';
//# sourceMappingURL=constants.js.map